"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _HeaderTop = _interopRequireDefault(require("../../shared/HeaderTop"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const WarningScreenHeader = () => {
  return /*#__PURE__*/_react.default.createElement(_HeaderTop.default, {
    id: "warnning-screen-header",
    isCloseButtonHidden: false
  });
};
var _default = WarningScreenHeader;
exports.default = _default;